import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "p-d03-details" }
const _hoisted_2 = {
  key: 0,
  class: "p-d03-details__list"
}
const _hoisted_3 = { class: "p-d03-details__list__description" }
const _hoisted_4 = {
  key: 1,
  class: "p-d03-details__list"
}
const _hoisted_5 = { class: "p-d03-details__list__description" }
const _hoisted_6 = {
  key: 2,
  class: "p-d03-details__list"
}
const _hoisted_7 = { class: "p-d03-details__list__description" }
const _hoisted_8 = { class: "p-d03-details__list__description__addition" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 3,
  class: "p-d03-details__list"
}
const _hoisted_11 = { class: "p-d03-details__list__description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PointNotation = _resolveComponent("PointNotation")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("p", { class: "p-d03-details__heading" }, "お支払い内容", -1)),
    (_ctx.points.all >= 0)
      ? (_openBlock(), _createElementBlock("dl", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("dt", { class: "p-d03-details__list__term" }, "保有ポイント合計", -1)),
          _createElementVNode("dd", _hoisted_3, [
            _createVNode(_component_PointNotation, {
              point: _ctx.points.all,
              "point-color": '#4f4f4f',
              "sign-is-exists": false,
              class: "p-d03-details__list__point"
            }, null, 8, ["point"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.points.use_point > 0)
      ? (_openBlock(), _createElementBlock("dl", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("dt", { class: "p-d03-details__list__term" }, "ご利用ポイント合計", -1)),
          _createElementVNode("dd", _hoisted_5, [
            _createVNode(_component_PointNotation, {
              point: _ctx.points.use_point,
              "point-color": '#4f4f4f',
              "sign-is-exists": false,
              class: "p-d03-details__list__point"
            }, null, 8, ["point"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.points.use_creditcard > 0)
      ? (_openBlock(), _createElementBlock("dl", _hoisted_6, [
          _cache[3] || (_cache[3] = _createElementVNode("dt", { class: "p-d03-details__list__term" }, "クレジット決済金額", -1)),
          _createElementVNode("dd", _hoisted_7, [
            _createVNode(_component_PointNotation, {
              point: _ctx.points.use_creditcard,
              "point-color": '#4f4f4f',
              unit: { point: '円' },
              "sign-is-exists": false,
              class: "p-d03-details__list__point"
            }, null, 8, ["point"]),
            _createElementVNode("p", _hoisted_8, [
              _createTextVNode(" （価格：" + _toDisplayString(_ctx.addComma(_ctx.points.use_creditcard_excluding_tax)) + "円／ 消費税" + _toDisplayString(_ctx.addComma(_ctx.points.use_creditcard_tax)) + "円） ", 1),
              _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
              (_ctx.points.use_creditcard_tax_rate > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, " 消費税率：" + _toDisplayString(_ctx.points.use_creditcard_tax_rate) + "％ ", 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.points.after_subtraction >= 0)
      ? (_openBlock(), _createElementBlock("dl", _hoisted_10, [
          _cache[4] || (_cache[4] = _createElementVNode("dt", { class: "p-d03-details__list__term" }, "申込み後の残りのポイント", -1)),
          _createElementVNode("dd", _hoisted_11, [
            _createVNode(_component_PointNotation, {
              point: _ctx.points.after_subtraction,
              "point-color": '#4f4f4f',
              "sign-is-exists": false,
              class: "p-d03-details__list__point"
            }, null, 8, ["point"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}